import React from 'react'

function About_poster() {
  return (
    <div>

    {/* -----------------------Mobile View------------------------ */}
    <div className='About_us_background_image d-sm-block d-md-none mt-5'>
        <div className='container-fluid About_background_color pt-5'>
            <div className='text-center About_Main_text py-5'>
                <h1 className='display-2 text-white'>About Us</h1>
                <h3 className='text-white fs-5 pt-1'>We're more than a story: we're a journey</h3>
            </div>
        </div>
    </div>

    {/* -------------------Desktop View------------------------- */}
    <div className='About_us_background_image d-none d-md-block mt-5'>
        <div className='container-fluid About_background_color py-5'>
            <div className='text-center pt-5 About_Main_text mt-5'>
                <h1 className='display-2 pt-5 text-white'>About Us</h1>
                <h3 className='text-white display-6 pt-4 pb-5 mb-5'>We're more than a story: we're a journey</h3>
            </div>
        </div>
    </div>
    </div>
  )
}

export default About_poster
